var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGgConnectLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 383",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5516_36625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.9 343.54H416.78V343.79H449.9V343.54Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22 348.26H322.53V348.51H331.22V348.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.78 334.26H396.59V334.51H415.78V334.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.65 335.94H52.46V336.19H95.65V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89 335.94H104.56V336.19H110.89V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15 340.16H131.47V340.41H225.15V340.16Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.01 282.85H43.91C40.76 282.85 38.2 280.29 38.2 277.14V5.71C38.2 2.56 40.76 0 43.91 0H237.01C240.16 0 242.72 2.56 242.72 5.71V277.14C242.72 280.29 240.16 282.85 237.01 282.85ZM43.91 0.25C40.9 0.25 38.45 2.7 38.45 5.71V277.14C38.45 280.15 40.9 282.6 43.91 282.6H237.01C240.02 282.6 242.47 280.15 242.47 277.14V5.71C242.47 2.7 240.02 0.25 237.01 0.25H43.91Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 282.85H260.21C257.06 282.85 254.5 280.29 254.5 277.14V5.71C254.5 2.56 257.06 0 260.21 0H453.31C456.46 0 459.02 2.56 459.02 5.71V277.14C459.02 280.29 456.46 282.85 453.31 282.85ZM260.21 0.25C257.2 0.25 254.75 2.7 254.75 5.71V277.14C254.75 280.15 257.2 282.6 260.21 282.6H453.31C456.32 282.6 458.77 280.15 458.77 277.14V5.71C458.77 2.7 456.32 0.25 453.31 0.25H260.21Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 327.45H0V327.7H500V327.45Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.75 209.46H266.45L267.49 199.28H417.79L416.75 209.46Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13 209.46H251.56L252.6 199.28H393.17L392.13 209.46Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.43 213.24H250.76L252.58 195.31H420.25L418.43 213.24ZM251.72 211.18H417.89L419.3 197.37H253.13L251.72 211.18Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.15 208.46H252.91L253.77 200.28H258.01L257.15 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.31 208.46H258.07L258.93 200.28H263.17L262.31 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47 208.46H263.23L264.09 200.28H268.33L267.47 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63 208.46H268.39L269.25 200.28H273.49L272.63 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79 208.46H273.55L274.41 200.28H278.65L277.79 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.95 208.46H278.71L279.57 200.28H283.81L282.95 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11 208.46H283.87L284.73 200.28H288.97L288.11 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.27 208.46H289.03L289.89 200.28H294.13L293.27 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.43 208.46H294.19L295.05 200.28H299.29L298.43 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.59 208.46H299.35L300.21 200.28H304.45L303.59 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 208.46H304.51L305.37 200.28H309.6L308.75 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91 208.46H309.67L310.53 200.28H314.76L313.91 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06 208.46H314.83L315.69 200.28H319.92L319.06 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22 208.46H319.99L320.85 200.28H325.08L324.22 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.38 208.46H325.15L326.01 200.28H330.24L329.38 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54 208.46H330.31L331.17 200.28H335.4L334.54 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.7 208.46H335.47L336.33 200.28H340.56L339.7 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86 208.46H340.63L341.49 200.28H345.72L344.86 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.02 208.46H345.79L346.65 200.28H350.88L350.02 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.18 208.46H350.95L351.8 200.28H356.04L355.18 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.34 208.46H356.11L356.96 200.28H361.2L360.34 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5 208.46H361.26L362.12 200.28H366.36L365.5 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66 208.46H366.42L367.28 200.28H371.52L370.66 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.82 208.46H371.58L372.44 200.28H376.68L375.82 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.98 208.46H376.74L377.6 200.28H381.84L380.98 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.14 208.46H381.9L382.76 200.28H387L386.14 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.3 208.46H387.06L387.92 200.28H392.16L391.3 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.03 212.91H422.72L424.14 196.6H428.8L428.68 197.98H425.41L424.23 211.52H437.76L438.95 197.98H435.6L435.73 196.6H440.45L439.03 212.91Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.28 204.75H430.89L432.26 189.16H433.64L432.28 204.75Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.95 192.52L432.86 189.95L428.16 192.28L427.63 191.05L433.04 188.37L437.76 191.33L436.95 192.52Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.72 164.02H279.43L280.46 153.83H430.76L429.72 164.02Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.58 164.02H264.53L265.57 153.83H416.62L415.58 164.02Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.4 167.79H263.73L265.55 149.86H433.22L431.4 167.79ZM264.69 165.73H430.86L432.27 151.92H266.1L264.69 165.73Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12 163.02H265.89L266.74 154.83H270.98L270.12 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28 163.02H271.05L271.9 154.83H276.14L275.28 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.44 163.02H276.2L277.06 154.83H281.3L280.44 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.6 163.02H281.36L282.22 154.83H286.46L285.6 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76 163.02H286.52L287.38 154.83H291.62L290.76 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92 163.02H291.68L292.54 154.83H296.78L295.92 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08 163.02H296.84L297.7 154.83H301.94L301.08 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24 163.02H302L302.86 154.83H307.1L306.24 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4 163.02H307.16L308.02 154.83H312.26L311.4 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.56 163.02H312.32L313.18 154.83H317.42L316.56 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72 163.02H317.48L318.34 154.83H322.58L321.72 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88 163.02H322.64L323.5 154.83H327.74L326.88 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.04 163.02H327.8L328.66 154.83H332.9L332.04 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2 163.02H332.96L333.82 154.83H338.06L337.2 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.36 163.02H338.12L338.98 154.83H343.21L342.36 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.52 163.02H343.28L344.14 154.83H348.37L347.52 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.67 163.02H348.44L349.3 154.83H353.53L352.67 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.83 163.02H353.6L354.46 154.83H358.69L357.83 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.99 163.02H358.76L359.62 154.83H363.85L362.99 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15 163.02H363.92L364.78 154.83H369.01L368.15 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.31 163.02H369.08L369.94 154.83H374.17L373.31 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.47 163.02H374.24L375.1 154.83H379.33L378.47 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63 163.02H379.4L380.26 154.83H384.49L383.63 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.79 163.02H384.56L385.41 154.83H389.65L388.79 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.95 163.02H389.72L390.57 154.83H394.81L393.95 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.11 163.02H394.88L395.73 154.83H399.97L399.11 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.27 163.02H400.03L400.89 154.83H405.13L404.27 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43 163.02H405.19L406.05 154.83H410.29L409.43 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59 163.02H410.35L411.21 154.83H415.45L414.59 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92 167.55H435.61L437.03 151.24H441.69L441.57 152.63H438.3L437.11 166.16H450.65L451.84 152.63H448.49L448.61 151.24H453.34L451.92 167.55Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.19 159.39H443.8L445.17 143.8H446.55L445.19 159.39Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.45 160.19L439.5 157.51L440.25 156.28L444.54 158.6L449.09 156.04L449.69 157.23L444.45 160.19Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7 129L69.58 130.37H192.3L192.42 129H69.7Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.42 129H69.7L69.58 130.37H192.3L192.42 129Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.79 113.39H71.22L78.62 28.73H201.2L193.79 113.39Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58 146.77C71.11 146.77 68.55 143.96 68.85 140.49C69.15 137.02 72.21 134.21 75.68 134.21C79.15 134.21 81.71 137.02 81.41 140.49C81.11 143.96 78.05 146.77 74.58 146.77Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 123.8H70.31L70.78 118.38H132.07L131.59 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11 143.19H167.43L167.9 137.78H191.58L191.11 143.19Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.88 123.8H187.47L187.94 118.38H193.35L192.88 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71 123.8H178.3L178.77 118.38H184.18L183.71 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54 123.8H169.12L169.6 118.38H175.01L174.54 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.65 23.5199H109.72L110.13 18.8599H202.06L201.65 23.5199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46 23.89H78.78L79.26 18.48H102.94L102.46 23.89Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.61 107.25L86.11 108.88L86.34 106.34H189.17L184.61 107.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27 108.88H75.92L76.14 106.34H179.49L179.27 108.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.28 109.82H75.56L75.95 105.35H190.67L190.28 109.82ZM76.12 109.3H189.81L190.11 105.86H76.42L76.12 109.3Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 382.61C357.082 382.61 443.89 377.542 443.89 371.29C443.89 365.038 357.082 359.97 250 359.97C142.917 359.97 56.11 365.038 56.11 371.29C56.11 377.542 142.917 382.61 250 382.61Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.58 334.96C403.58 334.96 396.55 319.63 404.58 304.52C412.61 289.41 414.93 285.85 409.82 282.75C404.7 279.65 402.35 294.84 402.35 294.84C402.35 294.84 398.04 284.39 401.6 273.46C405.16 262.53 407.4 244.72 402.53 242.81C397.67 240.9 401.6 265.02 397.38 273.25C397.38 273.25 393.83 264.1 393.25 255.31C392.67 246.52 393.58 232.51 389.74 228.91C385.9 225.31 383.44 227.8 387.21 247.18C390.98 266.56 390.96 282.31 390.96 282.31C390.96 282.31 382.62 256.89 377.03 256.15C371.43 255.41 371.44 263.64 376.23 270.78C381.02 277.92 390.26 290.71 391.77 297.29C391.77 297.29 382.62 278.16 374.39 284.02C366.16 289.88 381.56 301.44 388.42 305.61C395.28 309.79 400.05 335.96 400.05 335.96L403.59 334.95L403.58 334.96Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M403.58 334.96C403.58 334.96 396.55 319.63 404.58 304.52C412.61 289.41 414.93 285.85 409.82 282.75C404.7 279.65 402.35 294.84 402.35 294.84C402.35 294.84 398.04 284.39 401.6 273.46C405.16 262.53 407.4 244.72 402.53 242.81C397.67 240.9 401.6 265.02 397.38 273.25C397.38 273.25 393.83 264.1 393.25 255.31C392.67 246.52 393.58 232.51 389.74 228.91C385.9 225.31 383.44 227.8 387.21 247.18C390.98 266.56 390.96 282.31 390.96 282.31C390.96 282.31 382.62 256.89 377.03 256.15C371.43 255.41 371.44 263.64 376.23 270.78C381.02 277.92 390.26 290.71 391.77 297.29C391.77 297.29 382.62 278.16 374.39 284.02C366.16 289.88 381.56 301.44 388.42 305.61C395.28 309.79 400.05 335.96 400.05 335.96L403.59 334.95L403.58 334.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.03 341.25C398.03 341.25 404.87 325.82 396.66 310.83C388.45 295.84 386.08 292.31 391.16 289.14C396.24 285.97 398.77 301.12 398.77 301.12C398.77 301.12 402.96 290.61 399.27 279.73C395.58 268.85 393.13 251.08 397.97 249.1C402.81 247.12 399.17 271.3 403.48 279.46C403.48 279.46 406.91 270.25 407.39 261.46C407.87 252.67 406.79 238.66 410.59 235.01C414.39 231.36 416.88 233.81 413.34 253.24C409.8 272.67 410.01 288.42 410.01 288.42C410.01 288.42 418.04 262.88 423.63 262.05C429.22 261.23 429.31 269.46 424.6 276.67C419.9 283.88 410.81 296.81 409.38 303.41C409.38 303.41 418.3 284.15 426.6 289.89C434.9 295.63 419.64 307.41 412.83 311.69C406.02 315.97 401.57 342.21 401.57 342.21L398.02 341.25H398.03Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59 330.25H373.07L377.64 370.69H425.01L429.59 330.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.2 137.79L288.42 113.81H287L277.14 137.79H279.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71 137.92L294.23 120.66L293.11 120.41L281.08 137.55L282.71 137.92Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.01 137.73L229.8 113.75H231.22L241.08 137.73H239.01Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51 137.85L223.99 120.6L225.11 120.35L237.13 137.49L235.51 137.85Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89 135.1H258.87L259.41 107.85H260.35L260.89 135.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.39 137.73L239.86 138.8H241.23L240.79 137.73H239.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85 137.73L278.38 138.8H277.01L277.44 137.73H278.85Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88 137.79L236.53 139.01H237.88L236.71 137.58L235.88 137.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.37 137.79L281.72 139.01H280.38L281.54 137.58L282.37 137.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15 135.1L259.16 137.29H260.6V135.1H259.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71 145.07H237.01V148.62H242.71V145.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.37 145.07H275.67V148.62H281.37V145.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 146.64L270.98 147.98C263.12 148.83 255.2 148.83 247.34 147.98L234.95 146.64V138.95L245.01 137.64C254.4 136.42 263.91 136.42 273.3 137.64L283.36 138.95V146.64H283.37Z",
    fill: "#8D86C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.15 143.02C242.15 144.29 241.12 145.31 239.86 145.31C238.6 145.31 237.57 144.28 237.57 143.02C237.57 141.76 238.6 140.73 239.86 140.73C241.12 140.73 242.15 141.76 242.15 143.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23 143.03C241.23 143.79 240.62 144.4 239.86 144.4C239.1 144.4 238.49 143.79 238.49 143.03C238.49 142.27 239.1 141.66 239.86 141.66C240.62 141.66 241.23 142.27 241.23 143.03Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.85 143.03C252.85 143.43 252.53 143.76 252.12 143.76C251.71 143.76 251.39 143.44 251.39 143.03C251.39 142.62 251.71 142.3 252.12 142.3C252.53 142.3 252.85 142.62 252.85 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43 143.03C255.43 143.43 255.1 143.76 254.7 143.76C254.3 143.76 253.97 143.44 253.97 143.03C253.97 142.62 254.29 142.3 254.7 142.3C255.11 142.3 255.43 142.62 255.43 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.02 143.03C258.02 143.43 257.7 143.76 257.29 143.76C256.88 143.76 256.56 143.44 256.56 143.03C256.56 142.62 256.88 142.3 257.29 142.3C257.7 142.3 258.02 142.62 258.02 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.6 143.03C260.6 143.43 260.28 143.76 259.87 143.76C259.46 143.76 259.14 143.44 259.14 143.03C259.14 142.62 259.46 142.3 259.87 142.3C260.28 142.3 260.6 142.62 260.6 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19 143.03C263.19 143.43 262.87 143.76 262.46 143.76C262.05 143.76 261.73 143.44 261.73 143.03C261.73 142.62 262.05 142.3 262.46 142.3C262.87 142.3 263.19 142.62 263.19 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.78 143.03C265.78 143.43 265.46 143.76 265.05 143.76C264.64 143.76 264.32 143.44 264.32 143.03C264.32 142.62 264.64 142.3 265.05 142.3C265.46 142.3 265.78 142.62 265.78 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36 143.03C268.36 143.43 268.04 143.76 267.63 143.76C267.22 143.76 266.9 143.44 266.9 143.03C266.9 142.62 267.22 142.3 267.63 142.3C268.04 142.3 268.36 142.62 268.36 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25 222H219.2L218.69 219.62C216.35 213.32 204.34 213.32 204.34 213.32C201.37 213.49 198.46 216.27 197.63 220.17L197.24 222.01L197.25 222Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.19 195.42H160.16L162.79 218.48H184.85L180.2 195.42H180.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.74 221.41H187.7V221.67H150.29V218.48H184.85L180.2 195.42H160.17L159.06 185.64C159.12 184.31 160.23 183.25 161.56 183.25H178.72C180.06 183.25 181.16 184.3 181.23 185.64L188.74 221.41Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85 218.48H162.79L160.37 197.23L160.16 195.42H180.19L184.85 218.48Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.09 203.1L160.16 195.42H183.28L184.89 203.1H161.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.98 219.15H124.36C124.08 219.15 123.86 218.95 123.86 218.69V216.16C123.86 215.91 124.08 215.7 124.36 215.7H126.24C126.47 215.7 126.66 215.84 126.72 216.04L127.46 218.57C127.54 218.86 127.31 219.14 126.98 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 219.15H127.98C127.7 219.15 127.48 218.95 127.48 218.69V216.16C127.48 215.91 127.7 215.7 127.98 215.7H129.86C130.09 215.7 130.28 215.84 130.34 216.04L131.08 218.57C131.16 218.86 130.93 219.14 130.6 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22 219.15H131.6C131.32 219.15 131.1 218.95 131.1 218.69V216.16C131.1 215.91 131.32 215.7 131.6 215.7H133.48C133.71 215.7 133.9 215.84 133.96 216.04L134.7 218.57C134.78 218.86 134.55 219.14 134.22 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84 219.15H135.22C134.94 219.15 134.72 218.95 134.72 218.69V216.16C134.72 215.91 134.94 215.7 135.22 215.7H137.1C137.33 215.7 137.52 215.84 137.58 216.04L138.32 218.57C138.4 218.86 138.17 219.14 137.84 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45 219.15H138.83C138.55 219.15 138.33 218.95 138.33 218.69V216.16C138.33 215.91 138.55 215.7 138.83 215.7H140.71C140.94 215.7 141.13 215.84 141.19 216.04L141.93 218.57C142.01 218.86 141.78 219.14 141.45 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07 219.15H142.45C142.17 219.15 141.95 218.95 141.95 218.69V216.16C141.95 215.91 142.17 215.7 142.45 215.7H144.33C144.56 215.7 144.75 215.84 144.81 216.04L145.55 218.57C145.63 218.86 145.4 219.14 145.07 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69 219.15H146.07C145.79 219.15 145.57 218.95 145.57 218.69V216.16C145.57 215.91 145.79 215.7 146.07 215.7H147.95C148.18 215.7 148.37 215.84 148.43 216.04L149.17 218.57C149.25 218.86 149.02 219.14 148.69 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.31 219.15H149.69C149.41 219.15 149.19 218.95 149.19 218.69V216.16C149.19 215.91 149.41 215.7 149.69 215.7H151.57C151.8 215.7 151.99 215.84 152.05 216.04L152.79 218.57C152.87 218.86 152.64 219.14 152.31 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93 219.15H153.31C153.03 219.15 152.81 218.95 152.81 218.69V216.16C152.81 215.91 153.03 215.7 153.31 215.7H155.19C155.42 215.7 155.61 215.84 155.67 216.04L156.41 218.57C156.49 218.86 156.26 219.14 155.93 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55 219.15H156.93C156.65 219.15 156.43 218.95 156.43 218.69V216.16C156.43 215.91 156.65 215.7 156.93 215.7H158.81C159.04 215.7 159.23 215.84 159.29 216.04L160.03 218.57C160.11 218.86 159.88 219.14 159.55 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.17 219.15H160.55C160.27 219.15 160.05 218.95 160.05 218.69V216.16C160.05 215.91 160.27 215.7 160.55 215.7H162.43C162.66 215.7 162.85 215.84 162.91 216.04L163.65 218.57C163.73 218.86 163.5 219.14 163.17 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.79 219.15H164.17C163.89 219.15 163.67 218.95 163.67 218.69V216.16C163.67 215.91 163.89 215.7 164.17 215.7H166.05C166.28 215.7 166.47 215.84 166.53 216.04L167.27 218.57C167.35 218.86 167.12 219.14 166.79 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41 219.15H167.79C167.51 219.15 167.29 218.95 167.29 218.69V216.16C167.29 215.91 167.51 215.7 167.79 215.7H169.67C169.9 215.7 170.09 215.84 170.15 216.04L170.89 218.57C170.97 218.86 170.74 219.14 170.41 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.03 219.15H171.41C171.13 219.15 170.91 218.95 170.91 218.69V216.16C170.91 215.91 171.13 215.7 171.41 215.7H173.29C173.52 215.7 173.71 215.84 173.77 216.04L174.51 218.57C174.59 218.86 174.36 219.14 174.03 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 219.15H175.03C174.75 219.15 174.53 218.95 174.53 218.69V216.16C174.53 215.91 174.75 215.7 175.03 215.7H176.91C177.14 215.7 177.33 215.84 177.39 216.04L178.13 218.57C178.21 218.86 177.98 219.14 177.65 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H123.91C122.7 221.42 121.73 220.53 121.73 219.43C121.73 218.88 121.97 218.38 122.36 218.02C122.74 217.67 123.27 217.45 123.85 217.44H178.1C178.31 217.44 178.51 217.47 178.7 217.52C179.61 217.76 180.28 218.52 180.28 219.43H180.29Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H123.91C122.7 221.42 121.73 220.53 121.73 219.43C121.73 218.88 121.97 218.38 122.36 218.02C122.74 217.67 123.27 217.45 123.85 217.44H178.1C178.31 217.44 178.51 217.47 178.7 217.52C179.61 217.76 180.28 218.52 180.28 219.43H180.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H159.76C158.88 221.16 158.25 220.41 158.25 219.52C158.25 219.39 158.26 219.28 158.28 219.16C158.36 218.75 158.58 218.39 158.89 218.11C159.03 217.98 159.19 217.88 159.36 217.78C159.44 217.74 159.53 217.7 159.61 217.66C159.87 217.56 160.15 217.52 160.45 217.52H178.72C179.63 217.76 180.3 218.52 180.3 219.43H180.29Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73 130.65H213.19L206.97 198.2H212.51C213.43 198.2 214.25 197.34 214.35 196.28L220.22 132.57C220.32 131.51 219.65 130.65 218.74 130.65H218.73Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16 198.2H127.16C126.24 198.2 125.58 197.34 125.68 196.28L131.55 132.57C131.65 131.51 132.47 130.65 133.39 130.65H216.39C217.31 130.65 217.97 131.51 217.87 132.57L212 196.28C211.9 197.34 211.08 198.2 210.16 198.2Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.16 198.2H127.16C126.24 198.2 125.58 197.34 125.68 196.28L131.55 132.57C131.65 131.51 132.47 130.65 133.39 130.65H216.39C217.31 130.65 217.97 131.51 217.87 132.57L212 196.28C211.9 197.34 211.08 198.2 210.16 198.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66 184.64H132.27L136.45 136.86H211.84L207.66 184.64Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62 188.39H132.33C130.22 188.39 128.66 186.68 128.85 184.57L133 137.08C133.18 134.97 135.04 133.26 137.15 133.26H211.44C213.55 133.26 215.11 134.97 214.92 137.08L210.77 184.57C210.59 186.68 208.73 188.39 206.62 188.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66 184.64H132.27L136.45 136.86H211.84L207.66 184.64Z",
    fill: "#F4F4FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M207.387 184.78H131.997L136.177 137H211.567L207.387 184.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.86 165.87H164.32L165.16 156.33H167.88L167.81 157.14H165.9L165.21 165.06H173.12L173.82 157.14H171.86L171.93 156.33H174.7L173.86 165.87Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93 161.1H169.12L169.92 151.98H170.73L169.93 161.1Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5 161.56L166.6 160L167.04 159.28L169.55 160.64L172.21 159.14L172.56 159.83L169.5 161.56Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.98 166.31H149.44L150.27 156.77H152.99L152.92 157.58H151.01L150.32 165.5H158.24L158.93 157.58H156.97L157.05 156.77H159.81L158.98 166.31Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.03 161.54H154.22L155.02 152.42H155.83L155.03 161.54Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76 154.39L155.37 152.89L152.62 154.25L152.31 153.53L155.48 151.96L158.24 153.69L157.76 154.39Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.39 133.29L168.66 188.36H173.61L188.18 133.29H183.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.03 133.29L176.31 188.36H186.13L200.69 133.29H191.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38 233.18H150.04L160.71 359.52C160.83 360.93 159.72 362.14 158.3 362.14C157.06 362.14 156.02 361.2 155.9 359.96L143.38 233.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.49 232.3H310.15L320.82 359.52C320.94 360.93 319.83 362.14 318.41 362.14C317.17 362.14 316.13 361.2 316.01 359.96L303.49 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.17 232.3H109.45V254.71H308.17V232.3Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.26 232.47L272.49 254.69L308.17 254.71V232.3L273.26 232.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.24 232.47H109.47V254.88H270.24V232.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83 232.3H107.17L106.98 368.16C106.98 369.5 108.06 370.58 109.4 370.58C110.72 370.58 111.8 369.52 111.82 368.19L113.84 232.29L113.83 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94 232.3H267.28L267.09 368.16C267.09 369.5 268.17 370.58 269.51 370.58C270.83 370.58 271.91 369.52 271.93 368.19L273.95 232.29L273.94 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.17 232.3L106.98 368.16C106.98 369.5 108.06 370.58 109.4 370.58C110.72 370.58 111.8 369.52 111.82 368.19L113.84 232.29H107.18L107.17 232.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.94 232.3H267.28L267.09 368.16C267.09 369.5 268.17 370.58 269.51 370.58C270.83 370.58 271.91 369.52 271.93 368.19L273.95 232.29L273.94 232.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63 226.91C101.63 223.89 102.76 221.45 104.14 221.44H313.18C314.56 221.44 315.69 223.89 315.69 226.91C315.69 229.93 314.56 232.37 313.18 232.38H104.14C102.76 232.38 101.63 229.93 101.63 226.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.63 226.91C101.63 223.89 102.76 221.45 104.14 221.44H313.18C314.56 221.44 315.69 223.89 315.69 226.91C315.69 229.93 314.56 232.37 313.18 232.38H104.14C102.76 232.38 101.63 229.93 101.63 226.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.73 226.91C261.73 223.89 262.86 221.45 264.24 221.44H313.18C314.56 221.44 315.69 223.89 315.69 226.91C315.69 229.93 314.56 232.37 313.18 232.38H264.24C262.86 232.38 261.73 229.93 261.73 226.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.99 212.65C197.05 212.65 190.85 198.16 190.78 197.98L192.03 197.46C192.35 198.24 200.16 216.39 221.71 209.91C243.55 203.34 260.92 156.84 261.1 156.37L262.37 156.84C261.65 158.78 244.59 204.45 222.1 211.21C218.76 212.21 215.73 212.64 212.99 212.64V212.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06 148.46H255.11V221.99H287.06V148.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M287.06 148.46H255.11V221.99H287.06V148.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21 148.46H232.26V221.99H264.21V148.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 164.15C254 167.76 251.07 170.68 247.47 170.68C243.87 170.68 240.94 167.75 240.94 164.15C240.94 160.55 243.87 157.62 247.47 157.62C251.07 157.62 254 160.55 254 164.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38 164.2C251.38 166.36 249.63 168.11 247.47 168.11C245.31 168.11 243.56 166.36 243.56 164.2C243.56 162.04 245.31 160.29 247.47 160.29C249.63 160.29 251.38 162.04 251.38 164.2Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73 181.76C250.73 183.56 249.27 185.03 247.46 185.03C245.65 185.03 244.19 183.57 244.19 181.76C244.19 179.95 245.65 178.49 247.46 178.49C249.27 178.49 250.73 179.95 250.73 181.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.42 181.78C249.42 182.86 248.55 183.73 247.47 183.73C246.39 183.73 245.52 182.86 245.52 181.78C245.52 180.7 246.39 179.83 247.47 179.83C248.55 179.83 249.42 180.7 249.42 181.78Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.97 168.11H246.96V179.83H247.97V168.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.87 191.06H234.61V218.32H261.87V191.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 206.49C250.13 207.38 249.41 208.1 248.52 208.1C247.63 208.1 246.91 207.38 246.91 206.49C246.91 205.6 247.63 204.88 248.52 204.88C249.41 204.88 250.13 205.6 250.13 206.49Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.52 204.89C248.36 201 257.73 192.9 251.48 192.9C245.23 192.9 241.15 197.3 241.39 199.87C241.63 202.44 248.52 204.89 248.52 204.89Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54 208.23C244.8 209.3 234.73 202.08 236.19 208.16C237.65 214.23 242.89 217.17 245.33 216.34C247.77 215.51 248.54 208.23 248.54 208.23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 205.64C253.44 207.89 254.13 220.25 257.94 215.31C261.76 210.36 260.77 204.44 258.58 203.06C256.4 201.68 250.25 205.64 250.25 205.64H250.26Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7 103.62C256.78 100.3 261.96 100.11 265.28 103.19C265.37 103.28 265.47 103.37 265.56 103.46C267.07 104.98 269.44 102.64 267.92 101.1C263.43 96.56 256.11 96.53 251.57 101.02C251.5 101.09 251.43 101.17 251.35 101.24C249.87 102.79 252.21 105.16 253.71 103.6V103.62H253.7Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65 89.85C248.15 85.96 253.52 83.52 259.53 83.5C265.52 83.43 271.31 85.65 275.73 89.7C277.29 91.16 279.66 88.83 278.09 87.34C273.05 82.68 266.43 80.12 259.56 80.18C252.64 80.18 246.49 83.01 241.32 87.49C239.7 88.91 242.05 91.27 243.68 89.85H243.64H243.65Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.61 97.4801C253.61 90.7901 263.9 90.23 270.59 96.24C270.91 96.53 271.22 96.83 271.52 97.14C273.02 98.68 275.38 96.33 273.88 94.78C266.4 86.96 254 86.6901 246.18 94.1601C245.86 94.4601 245.56 94.77 245.26 95.1C243.81 96.67 246.15 99.04 247.62 97.46V97.4801H247.61Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 355.47L175.34 352.8L172.62 331.56L161.56 335.49L166.35 355.47Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.32 329.57L171.99 325.23L173.74 340.51L163.38 343.41L160.32 329.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11 351.27L165.87 354.05C165.51 354.13 165.27 354.54 165.34 354.97L166.89 364.73C167.12 365.78 168.01 366.44 168.9 366.21C172.45 365.17 174.11 364.47 178.61 363.25C181.38 362.5 187.72 360.7 191.6 359.98C195.48 359.27 194.69 354.73 192.99 354.61C185.32 354.14 180.92 353.21 177.83 351.51C177.29 351.21 176.69 351.12 176.11 351.26V351.27Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51 351.85C182.73 351.46 182.72 350.99 182.5 350.61C182.39 350.35 182.14 350.16 181.86 350.13C180.65 349.97 178.47 352.34 178.23 352.62C178.19 352.7 178.2 352.78 178.25 352.85C178.28 352.93 178.36 352.98 178.44 352.97C179.27 352.97 180.09 352.89 180.9 352.72C181.53 352.63 182.1 352.32 182.51 351.84V351.85ZM181.76 350.56C181.9 350.58 182.01 350.68 182.06 350.81C182.22 351.04 182.24 351.35 182.12 351.6C181.8 352.13 180.6 352.41 178.89 352.53C179.79 351.6 181.13 350.46 181.76 350.56Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 352.92C179.31 352.16 180.22 349.93 179.77 348.98C179.61 348.63 179.22 348.44 178.85 348.52C178.5 348.54 178.19 348.74 178.02 349.04C177.3 350.14 178.17 352.72 178.17 352.84C178.2 352.91 178.26 352.97 178.33 352.99C178.37 352.99 178.43 352.99 178.43 352.99C178.47 352.99 178.51 352.97 178.54 352.93L178.53 352.92ZM178.89 348.95C179.21 348.92 179.36 349.04 179.36 349.16C179.47 350.29 179.15 351.41 178.46 352.31C178.1 351.33 178.07 350.27 178.36 349.27C178.45 349.12 178.6 349.01 178.77 348.97L178.88 348.95H178.89Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8 240.35C120.8 240.35 174.04 244.84 172.74 267.96C171.67 286.89 168.86 281.74 174.38 338.02L160.99 338.76C160.99 338.76 147.36 292.73 149.2 274.44C134.19 274.44 99.83 275.76 94.84 262.22C92.36 255.34 91.16 248.07 91.28 240.77L120.81 240.36L120.8 240.35Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85 341.36L176.35 338.36L176.07 330.62L157.95 334.65L158.85 341.36Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.08 358.26L209.55 354.24L203.62 333.67L193.29 339.24L201.08 358.26Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.16 333.58L202.03 327.51L206.09 342.34L196.3 346.79L191.16 333.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.08 352.62L200.38 356.93C200.03 357.06 199.86 357.5 199.99 357.92L203.01 367.33C203.4 368.33 204.38 368.84 205.23 368.49C208.58 366.92 210.11 365.98 214.38 364.08C217.01 362.92 222.99 360.17 226.72 358.87C230.45 357.58 228.97 353.21 227.27 353.35C219.62 354.05 215.12 353.81 211.82 352.6C211.24 352.38 210.63 352.39 210.09 352.62H210.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49 352.21C216.65 351.8 216.57 351.33 216.29 350.99C216.14 350.75 215.87 350.6 215.58 350.62C214.36 350.64 212.57 353.32 212.37 353.63C212.35 353.71 212.37 353.8 212.42 353.86C212.46 353.93 212.55 353.97 212.63 353.95C213.45 353.83 214.25 353.62 215.03 353.33C215.64 353.15 216.16 352.75 216.49 352.21ZM215.55 351.05C215.69 351.05 215.82 351.13 215.89 351.25C216.08 351.46 216.15 351.75 216.07 352.02C215.83 352.59 214.69 353.05 213.02 353.43C213.77 352.37 214.91 351.05 215.56 351.04L215.55 351.05Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72 353.88C213.37 353.01 213.93 350.66 213.34 349.8C213.12 349.48 212.72 349.35 212.36 349.49C212.02 349.57 211.74 349.81 211.62 350.13C211.08 351.33 212.33 353.75 212.35 353.86C212.39 353.93 212.45 353.97 212.53 353.98C212.57 353.98 212.63 353.96 212.63 353.96C212.67 353.95 212.71 353.92 212.73 353.89L212.72 353.88ZM212.47 349.9C212.78 349.82 212.94 349.92 212.97 350.04C213.25 351.13 213.11 352.3 212.57 353.29C212.07 352.38 211.87 351.33 212.01 350.3C212.08 350.14 212.21 350.01 212.37 349.94L212.48 349.9H212.47Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 240.35C137 240.35 196.34 246.46 196.41 266.58C196.54 299.87 206.04 338.02 206.04 338.02L194.31 343.83C194.31 343.83 173.89 302.47 174.2 276.52C157.88 271.84 115.65 279.71 110.65 266.18C106.56 255.11 108.77 240.35 108.77 240.35H136.64H136.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44 345.52L208.16 338.45L206.9 332.01L190.32 337.74L192.44 345.52Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24 169.32C108.51 172.59 107.06 175.75 105.61 179.04C104.16 182.33 102.85 185.62 101.63 189.01C100.41 192.39 99.32 195.87 98.4 199.48C97.41 203.23 96.82 207.08 96.63 210.95C96.53 213.23 96.75 215.5 97.3 217.72C97.64 219.08 98.18 220.38 98.88 221.59C99.29 222.28 99.77 222.92 100.3 223.51L100.73 223.98C100.97 224.21 101.24 224.45 101.49 224.65C101.92 224.98 102.38 225.27 102.87 225.51C103.59 225.87 104.34 226.16 105.12 226.36C105.73 226.52 106.36 226.65 106.98 226.73C108.05 226.85 109.13 226.91 110.22 226.89C112.14 226.89 114.06 226.78 115.96 226.54C123.07 225.62 130.06 223.99 136.85 221.69L135.61 215.77C128.83 216.23 121.92 216.75 115.42 216.71C113.81 216.63 112.23 216.62 110.77 216.47C110.12 216.4 109.48 216.29 108.84 216.13C108.31 216.01 107.87 215.79 108.03 215.81C108.13 215.85 108.23 215.91 108.32 215.97C108.42 216.04 108.52 216.12 108.61 216.21C108.61 216.21 108.56 216.12 108.52 216.02C108.4 215.71 108.31 215.39 108.25 215.06C108.07 213.88 108.04 212.69 108.14 211.5C108.45 208.47 109.05 205.48 109.94 202.56C110.82 199.41 111.91 196.36 113.09 193.27C114.27 190.17 115.53 187.08 116.9 184C118.27 180.92 119.7 177.84 121.1 174.94L110.23 169.33L110.24 169.32Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61 217.19L139.84 213.59L142.99 221.39C142.99 221.39 134.6 224.4 132.98 222.17L132.62 217.2L132.61 217.19Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46 215.32L148.42 220.57L142.99 221.33L139.84 213.54L145.46 215.32Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74 182.5C133.09 185.89 131.61 182.05 133.09 185.33C134.58 188.61 136.06 191.84 137.64 195.07C140.8 201.64 144.35 208.03 148.26 214.19C149.32 215.76 150.38 217.32 151.57 218.88C152.16 219.67 152.82 220.44 153.52 221.24C153.9 221.64 154.21 222.02 154.66 222.43L155.3 223.05L155.66 223.39C156.67 224.26 157.86 224.89 159.14 225.24C159.82 225.43 160.5 225.58 161.2 225.68C162.33 225.82 163.48 225.86 164.62 225.82C166.59 225.76 168.56 225.56 170.5 225.24C177.7 223.97 184.75 221.97 191.55 219.27L191.61 211.8C184.74 212.63 177.72 213.51 171.11 213.79C169.55 213.85 167.99 213.83 166.44 213.73C165.81 213.68 165.19 213.58 164.58 213.43C164.38 213.38 164.19 213.31 164.01 213.22C163.95 213.22 164.01 213.15 164.3 213.33C164.4 213.39 164.5 213.46 164.59 213.54C164.59 213.54 164.52 213.44 164.48 213.41L164.18 213.08C163.99 212.89 163.76 212.57 163.53 212.32C163.09 211.77 162.65 211.17 162.2 210.53C161.32 209.27 160.46 207.86 159.61 206.44C157.91 203.59 156.33 200.57 154.78 197.51C153.23 194.45 151.74 191.33 150.28 188.18C147.36 181.91 147.4 182.57 144.68 176.25L131.74 182.53V182.5Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16 212.83L196.79 210.82L200.57 221.26C200.57 221.26 189.46 222.37 187.41 219.35L187.16 212.82V212.83Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11 213.46L207.77 220.53L200.57 221.26L196.79 210.82L204.11 213.46Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53 139.96C137.12 142.07 137.98 144.1 139.11 145.98C137.85 146.91 135.93 146.16 135.93 146.16L136.53 139.96Z",
    fill: "#A02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19 145.77C136.95 145.85 136.69 145.89 136.44 145.9C134.57 145.94 133 143.97 132.95 141.51C132.9 139.05 134.38 137.02 136.25 136.98C137.2 136.96 138.09 137.43 138.75 138.32C139.36 139.14 139.72 140.22 139.74 141.37C139.79 143.44 138.71 145.29 137.19 145.78V145.77ZM135.65 137.57C134.35 137.98 133.41 139.59 133.45 141.49C133.5 143.67 134.83 145.42 136.43 145.39C136.63 145.39 136.84 145.35 137.04 145.29C138.36 144.87 139.28 143.22 139.24 141.37C139.22 140.32 138.9 139.34 138.35 138.61C137.79 137.86 137.04 137.46 136.26 137.47C136.05 137.47 135.85 137.51 135.65 137.57Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19 146.34L117.43 151.81L124.58 159.26C123.99 160.12 123.57 161.09 123.33 162.11C122.69 164.34 122.15 165.98 126.99 168.15C128.05 168.58 128.76 169.59 128.8 170.73C128.8 172.11 127.72 173.6 122.92 173.69C118.29 173.67 113.79 172.17 110.07 169.41C108.24 168.12 108.43 166.93 109.57 165.05C112.94 159.72 112.86 152.25 112.19 146.34Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23 139.6C138.29 140.34 138.02 140.96 137.64 140.99C137.26 141.02 136.9 140.45 136.84 139.71C136.78 138.97 137.05 138.35 137.43 138.32C137.81 138.29 138.17 138.86 138.23 139.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59 149.56C135.44 153.77 132.4 156.92 128.78 158.4C127.49 158.93 126.13 159.25 124.74 159.32C121.55 159.49 118.29 158.37 115.7 155.64C111.15 150.82 111.45 145.37 111.15 136.1C111.08 134.22 111.41 132.35 112.13 130.61C114.88 124.04 122.42 120.93 129 123.67C137.96 127.47 138.82 141.25 136.58 149.56H136.59Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.77 158.41C127.48 158.94 126.12 159.26 124.73 159.33L124.57 159.26L125.45 157.54C125.45 157.54 125.99 159.01 128.76 158.41H128.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.361 136.447L126.227 136.929L140.034 140.765L140.168 140.284L126.361 136.447Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.04 141.93C127.41 144.67 125.43 147.35 124.99 150.5C124.8 151.82 114.74 153.79 112.33 151.27C109.91 148.75 108.45 145.45 107.46 142.1C106.25 137.98 105.7 133.54 106.79 129.38C107.42 126.97 108.66 124.64 110.65 123.15C112.64 121.66 115.46 121.14 117.68 122.28C122.28 119.27 128.6 119.14 133.32 121.96C138.04 124.78 140.91 130.41 140.43 135.89C140.4 136.21 140.35 136.55 140.12 136.77C139.83 137.05 139.37 137.02 138.97 136.97C137.06 136.74 135.15 136.51 133.25 136.28C132.53 136.19 131.65 135.96 131.52 135.25C131.44 134.8 130.96 132.47 130.94 132.13L129.06 141.93H129.04Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73 141.04C123.15 143.09 124.32 144.9 126 146.14C128.17 147.71 130.36 145.48 130.34 142.85C130.32 140.49 128.77 137.22 126.3 136.7C123.84 136.18 122.22 138.51 122.73 141.04Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78 118.25C116.06 118.14 117.3 119.06 117.76 120.25C118.04 120.97 118.31 122.69 117.51 123.06C116.62 121.4 116.02 119.73 114.78 118.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6 169.36C95.4 167.24 99.11 165.11 101.4 165.11H102.91C105.54 165.11 108.83 165.32 112.01 165.69C118.08 166.36 124.11 167.38 130.07 168.73C132.81 169.45 135.45 170.37 137.56 171.15C140.24 172.21 141.81 172.92 141.81 172.92C141.81 172.92 138.88 192.45 137.36 211.84C136.52 222.63 136.87 233.35 136.6 240.72H91.29C89.73 231.86 89.97 224.14 89.85 208.14C89.78 198.54 91.34 178.09 94.62 169.35L94.6 169.36Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.33 201.01C137.99 205.08 137.64 209.35 137.27 213.62C131.96 205.87 129.02 184.66 129.02 184.66L138.33 201.02V201.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36 174.36C150.85 178.01 157.21 196.71 157.21 196.71L142.35 207.92C136.68 202.56 128.38 189.25 127.48 183.93C126.02 175.76 133.96 168.54 144.36 174.36Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18 373.68C157.18 376.23 159.25 378.3 161.8 378.3C164.35 378.3 166.42 376.23 166.42 373.68C166.42 371.13 164.35 369.06 161.8 369.06C159.25 369.06 157.18 371.13 157.18 373.68Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26 373.68C88.26 376.23 86.19 378.3 83.64 378.3C81.09 378.3 79.02 376.23 79.02 373.68C79.02 371.13 81.09 369.06 83.64 369.06C86.19 369.06 88.26 371.13 88.26 373.68Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22 372.21C127.22 374.76 125.15 376.83 122.6 376.83C120.05 376.83 117.98 374.76 117.98 372.21C117.98 369.66 120.05 367.59 122.6 367.59C125.15 367.59 127.22 369.66 127.22 372.21Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.04 366.5V357.57H137.27C139.87 357.57 142.46 357.81 145.01 358.29L169.65 363.08C170.87 363.32 171.66 364.49 171.42 365.71C171.21 366.79 170.25 367.56 169.15 367.52L124.03 366.5H124.04Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.04 366.5V357.57H110.8C108.2 357.57 105.61 357.81 103.06 358.29L75.37 362.72C74.16 362.96 73.36 364.13 73.6 365.35C73.81 366.43 74.77 367.2 75.87 367.16L124.05 366.5H124.04Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24 313.11H115.85V360.28H132.24V313.11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87 283.22H118.19V313.34H129.87V283.22Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.88 288.81L118.19 291.75V283.22H129.88V288.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.74 240.19H161.8V265.52H167.74V240.19Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M167.74 240.19H161.8V265.52H167.74V240.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.04 283.22V173.1C132.04 168.93 130.24 164.96 127.1 162.22L119.25 155.35C116.61 153.04 113.23 151.77 109.72 151.77H81.37L67.51 166.51V283.22H132.03H132.04Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25 261.92H109.57V283.23H184.79C189.01 283.23 192.44 279.81 192.44 275.59C192.44 274.22 192.07 272.87 191.37 271.69C187.79 265.64 181.28 261.93 174.25 261.93V261.92Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.51 166.52V283.23H184.79C189.01 283.23 192.44 279.81 192.44 275.58C192.44 274.21 192.08 272.86 191.38 271.68C187.8 265.64 181.31 261.92 174.29 261.92H141.71C136.37 261.92 132.04 257.59 132.04 252.25V173.1C132.04 168.94 130.25 164.96 127.1 162.22L119.25 155.35C116.62 153.03 113.23 151.77 109.72 151.77H81.37L67.51 166.51V166.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6 283.22V173.1C122.6 168.93 120.8 164.96 117.66 162.22L109.81 155.35C107.17 153.04 103.79 151.77 100.28 151.77H78.18C74.19 151.77 70.37 153.42 67.64 156.33L61.99 162.34C59.47 165.02 58.07 168.56 58.07 172.25V272.21C58.07 278.3 63.01 283.24 69.1 283.24H122.6V283.22Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 283.22V173.1C122.6 168.93 120.8 164.96 117.66 162.22L109.81 155.35C107.17 153.04 103.79 151.77 100.28 151.77H78.18C74.19 151.77 70.37 153.42 67.64 156.33L61.99 162.34C59.47 165.02 58.07 168.56 58.07 172.25V272.21C58.07 278.3 63.01 283.24 69.1 283.24H122.6V283.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.61 247.92C157.68 243.36 171.9 243.36 184.97 247.92C187.68 248.94 190.73 247.78 192.08 245.21C193.29 242.65 191.67 239.34 188.37 238.18C173.11 232.85 156.49 232.85 141.23 238.18C137.94 239.33 136.31 242.65 137.52 245.21C138.87 247.76 141.9 248.92 144.6 247.92H144.61Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M144.61 247.92C157.68 243.36 171.9 243.36 184.97 247.92C187.68 248.94 190.73 247.78 192.08 245.21C193.29 242.65 191.67 239.34 188.37 238.18C173.11 232.85 156.49 232.85 141.23 238.18C137.94 239.33 136.31 242.65 137.52 245.21C138.87 247.76 141.9 248.92 144.6 247.92H144.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5516_36625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 382.61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgConnectLogin);
export default __webpack_public_path__ + "static/media/gg-connect-login.9eca35c5fd25fc8e4d256d360e25c67c.svg";
export { ForwardRef as ReactComponent };